export default async function ({ store, route, redirect }) {
  await store.dispatch('nuxtClientInit', { route, redirect })
}
